import { AbilityBuilder, createMongoAbility, type MongoAbility } from '@casl/ability';
import type { DecodedJwt } from '@/features/auth/types';

export type Action = 'create' | 'read' | 'update' | 'delete' | 'manage' | 'approve' | 'export' | 'impersonate';
export type Subject = string;
export type AppAbility = MongoAbility<[Action, Subject]>;

export function buildAbilityFromJwt(decoded: DecodedJwt | null): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (!decoded) return build();

  const isSuper = decoded.superadmin === 'True';
  if (isSuper) {
    can('manage', 'all');
    return build();
  }

  const claims = Array.isArray(decoded.claims) ? decoded.claims : [];
  for (const claim of claims) {
    // Expect format "Subject.action" (e.g. "Project.create", "User.read")
    const [subject, action] = claim.split('.', 2);
    if (subject && action) {
      can(action as Action, subject);
    }
  }
  // Always allow reading own user/preferences
  can('read', 'CurrentUser');
  return build();
}
